import { Component, OnInit } from "@angular/core";
import { PermissionsService } from "@emc-state/permissions/permissions.service";
import { PermissionsQuery } from "@emc-state/permissions/permissions.query";
import { takeUntil, filter, take } from "rxjs/operators";
import { AuthManager } from "@emc-modules/core/managers/auth.manager";
import { Unsubscribe } from "../../../../unsubscribe";
import { Router } from "@angular/router";
import { combineLatest } from "rxjs";
import {
  projectDocumentsUrl,
  projectInspectionsUrl,
  qrDirectAccessUrl
} from "@emc-utils/common-utils";

@Component({
  selector: "ae-bootstrap-component",
  templateUrl: "bootstrap.component.html",
  styleUrls: ["bootstrap.component.scss"]
})
export class BootstrapComponent extends Unsubscribe implements OnInit {
  loading: boolean;

  constructor(
    private permissionsService: PermissionsService,
    private authManager: AuthManager,
    private router: Router,
    private permissionsQuery: PermissionsQuery
  ) {
    super();
  }

  ngOnInit() {
    this.permissionsQuery
      .selectLoading()
      .pipe(takeUntil(this._destroyed$))
      .subscribe(l => (this.loading = l));

    // First, wait for a return URL. Then conditionally fetch data and navigate.
    this.authManager
      .getReturnUrl()
      .pipe(
        takeUntil(this._destroyed$),
        filter((url: string) => !!url),
        take(1)
      )
      .subscribe((url: string) => {
        // Skip data fetching for project inspections URL
        if (
          projectInspectionsUrl.test(url) ||
          qrDirectAccessUrl.test(url) ||
          projectDocumentsUrl.test(url)
        ) {
          this.router.navigateByUrl(url);
          return;
        }

        // Fetch permissions and logged-in user first
        this.permissionsService.list().subscribe();
        this.authManager.getLoggedInUser().subscribe();

        const bootstrap = combineLatest(
          this.permissionsQuery.selectLoaded$.pipe(takeUntil(this._destroyed$)),
          this.authManager.isLoaded(),
          (permissionLoaded, userLoaded) => ({
            permissionLoaded,
            userLoaded
          })
        );

        bootstrap.pipe(takeUntil(this._destroyed$)).subscribe((data: any) => {
          if (data.permissionLoaded && data.userLoaded) {
            this.authManager.setBootstrapped(true);
            this.router.navigateByUrl(url);
          }
        });
      });
  }
}
